import { Input } from '@cian/ui-kit';
import cx from 'clsx';
import { Field } from 'formik';
import * as React from 'react';

import { Label } from './Label';
import { useFieldHasErrors } from './utils';
import * as styles from '../index.css';

export const ActivityScope = () => {
  const invalid = useFieldHasErrors('activityScope');

  return (
    <div className={cx(styles['field'], styles['span-columns'])}>
      <Label invalid={invalid}>Сфера деятельности</Label>
      <Field name="activityScope" as={Input} placeholder="Профессия или компания" custom={{ invalid, size: 'XS' }} />
    </div>
  );
};
